import React, { FC } from 'react';
import { useProjectConfigContext } from '../../../contexts/ProjectConfigContext';
import SelectWithSearch from './SelectWithSearch';
import { ISelectOption } from '../../../interface/form.interface';
import { fromDecimalNCR } from '../../../helpers/language';

type TypeSelectCarMaker = {
    name: string,
    value: number,
    onBlur?: (e: React.FocusEvent<HTMLInputElement, Element>) => void,
    onChange?: (name: string | number, value: string | number) => void,
    errorMsg?: string | undefined,
}

const SelectCarMaker: FC<TypeSelectCarMaker> = ({
    name,
    value,
    onBlur = (e) => { },
    onChange = (e) => { },
    errorMsg = '',
}) => {

    const { projectConfigState } = useProjectConfigContext();
    let makers: ISelectOption[] = [{ value: -1, label: 'אין אופציות' }];

    if (projectConfigState.makers !== undefined) {

        const makerList = projectConfigState.makers;
        makers = makerList.map(maker => {
            return { label: fromDecimalNCR(maker.name), value: maker.id }
        });
    }

    const valueStr = makers.find(option => option.value === value);

    return (
        <SelectWithSearch
            errorMsg={errorMsg}
            name={name}
            label={'דגם רכב'}
            value={valueStr ? valueStr : null}
            isRequired={true}
            selects={makers}
            handleBlur={onBlur}
            handleChange={onChange} />
    );
}

export default SelectCarMaker;